module.exports = __webpack_public_path__ + "website/img/core11_2.ab47713c.png";